export default __webpack_public_path__ + "static/media/deposit-icon.cec84cc0.svg";